import { apiFetch } from '@/lib/apiClient';
import type { SearchResults } from '@coreltb/shared/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Globalna szukajka — uzywana przez Topbar GlobalSearch (Ctrl+K).
 *
 * Min 2 znaki wymagane (zapobiega lawinie zapytan przy pisaniu).
 * Debounce robimy w komponencie (250ms), tu tylko wlaczamy/wylaczamy query.
 *
 * staleTime 30s — uzytkownik moze szybko zamknac/otworzyc dropdown
 * z tym samym query, nie chcemy refetchowac.
 */
export function useGlobalSearch(query: string) {
  const trimmed = query.trim();
  const enabled = trimmed.length >= 2;
  return useQuery({
    queryKey: ['search', trimmed],
    queryFn: () => apiFetch<SearchResults>('/api/search', { query: { q: trimmed } }),
    enabled,
    staleTime: 30 * 1000,
    placeholderData: (prev) => prev,
  });
}
